export default {
  metaInfo: {
    title: "회원가입"
  },
  data() {
    return {
      userAgent: ""
    };
  },
  methods: {
    clickDownloadApp(type) {
      let url = "";

      if (type === "ios") {
        url = "https://apps.apple.com/kr/app/%EB%B9%A0%EB%A6%84/id1484604007";
      } else {
        url =
          "https://play.google.com/store/apps/details?id=com.quickuser&hl=ko";
      }
      window.open(url);
    }
  },
  created() {
    //userAgent 확인
    const checkUserAgent = navigator.userAgent.toLowerCase();

    //모바일 확인
    const isMobile = /iphone|ipad|ipod|android/i.test(checkUserAgent);

    if (isMobile) {
      //mobile
      if (checkUserAgent.indexOf("android") > -1) {
        return (this.userAgent = "android");
      } else if (
        checkUserAgent.indexOf("iphone") > -1 ||
        checkUserAgent.indexOf("ipad") > -1
      ) {
        return (this.userAgent = "ios");
      }
    } else {
      //pc
      return (this.userAgent = "web");
    }
  }
};
